import { createApi } from '@reduxjs/toolkit/query/react';
import apiRoutesV2 from 'src/config/api/routes';
import { appBaseQuery } from 'src/modules/shared/slices/helpers';

export const stepperApi = createApi({
  reducerPath: 'stepperApi',
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    postStepper: builder.mutation<void, { key: string; index: string }>({
      query: ({ key, index }) => ({
        url: apiRoutesV2.stepper(key, index),
        method: 'POST',
      }),
    }),
  }),
});

export const { usePostStepperMutation } = stepperApi;
